import type { ReactNode } from "react";

/**
 * A titled group of related form fields. Keeps the edit dialog scannable by
 * putting like fields together (contact, employment, organization, …) instead
 * of one long grid.
 */
export function FormSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <section className="space-y-3 border-t pt-4 first:border-t-0 first:pt-0">
      <div>
        {/* Bolder + slightly larger so section headers stand out, matching the
            profile page's DetailSection headers. */}
        <h3 className="font-bold text-base text-foreground">{title}</h3>
        {description && <p className="mt-1 text-muted-foreground text-xs">{description}</p>}
      </div>
      {children}
    </section>
  );
}
